import { Routes, Route } from "react-router-dom";

import LoginPage from "../pages/login/index";
import SubjectsPage from "../pages/subjects/index";
import LevelsPage from "../pages/levels/index";
import NotFoundPage from "../pages/notfound/index";
import TopicsPage from "../pages/topics/index";
import ProfilePage from "../pages/profile/index";
import SubtopicsPage from "../pages/subtopics/index";
import CategoriesPage from "../pages/categories/index";
import ReportsPage from "../pages/reports/index";
import OverallReport from  "../pages/overallReport/index";

function AppRoutes({ handleClick }) {
    return (
        <Routes>
            <Route path="/login" element={<LoginPage handleClick={handleClick} />} />
            <Route path="/" element={<SubjectsPage handleClick={handleClick} />} />
            <Route path="/levels" element={<LevelsPage handleClick={handleClick} />} />
            <Route path="/topics" element={<TopicsPage handleClick={handleClick} />} />
            <Route path="*" element={<NotFoundPage handleClick={handleClick} />} />
            <Route path="/profile" element={<ProfilePage handleClick={handleClick} />} />
            <Route path="/subtopics" element={<SubtopicsPage handleClick={handleClick} />} />
            <Route path="/categories" element={<CategoriesPage handleClick={handleClick} />} />
            <Route path="/reports" element={<ReportsPage handleClick={handleClick} />} />
            <Route path="/overall-report" element={<OverallReport handleClick={handleClick} />} />
        </Routes>
    );
}

export default AppRoutes;